module.exports = __webpack_public_path__ + "650cdc57.svg";